import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { AdminDashboardService } from '../../../services/admin-dashboard.service';
import { EntityService } from '../../../services/entity.service';
import { CommonModule } from '@angular/common';

interface FanDetails {
  id: number;
  name: string;
  email: string;
  profile_picture?: string;
  category: string;
  biography: string;
  status: 'active' | 'inactive' | 'pending';
  registrationDate: Date;
}

@Component({
  selector: 'app-admin-fans-dertails',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './admin-fans-dertails.component.html',
  styleUrls: ['./admin-fans-dertails.component.scss']
})
export class AdminFansDertailsComponent implements OnInit {
  fanId!: number;
  fan: FanDetails | null = null;
  loading: boolean = true;
  error: string = '';
  videos: any[] = [];

  constructor(
    private route: ActivatedRoute,
    private adminService: AdminDashboardService,
    private entityService: EntityService
  ) {}

  ngOnInit() {
    this.fanId = Number(this.route.snapshot.paramMap.get('id'));
    if (isNaN(this.fanId)) {
      this.error = 'ID du fan invalide';
      this.loading = false;
      return;
    }

    this.loadFanDetails();
    this.loadFanVideos();
  }

  private loadFanDetails() {
    this.loading = true;
    this.adminService.getCelebrityDetails(this.fanId).subscribe({
      next: (data) => {
        this.fan = data.data ?? null; 
        this.loading = false;
      },
      error: () => {
        this.error = 'Erreur lors du chargement des détails';
        this.loading = false;
      }
    });
  }

  private loadFanVideos() {
    this.entityService.getDataById('/userVideos', this.fanId).subscribe({
      next: (data: any) => {
        this.videos = data.data || [];
      },
      error: () => {
        this.error = 'Erreur lors du chargement des vidéos';
      }
    });
  }

  updateStatus(status: 'active' | 'inactive') {
    if (!this.fan?.id) return;
    this.adminService.updateCelebrityStatus(this.fan.id, status).subscribe({
      next: () => this.loadFanDetails(),
      error: () => (this.error = 'Erreur lors de la mise à jour du statut')
    });
  }
}
